<script lang="ts">
    import { REVIEWS_WIDGET_NAMES } from "@/constants/widget-names";
    import ReviewsTheme from "@apps/reviews/components/ReviewsTheme/ReviewsTheme.svelte";
    import ReviewsStorefrontValuesService from "@apps/reviews/services/ReviewsStorefrontValuesService";
    import { ProductIdManagerInterface } from "@lib/ProductIdManager/ProductIdManagerInterface";
    import { filter, lastValueFrom, tap } from "rxjs";
    import { onMount } from "svelte";

    import ReviewsGalleryManager from "../reviews_gallery_widget/ReviewsGalleryManager";
    import ProductReviewsMiniSlider from "./components/ProductReviewsMiniSlider.svelte";
    import ProductReviewsMiniSliderWidgetReviewsQuery from "./queries/ProductReviewsMiniSliderWidgetReviewsQuery";
    import ProductReviewsMiniSliderWidgetReviewsService from "./services/ProductReviewsMiniSliderWidgetReviewsService";

    export let reviewsQuery: ProductReviewsMiniSliderWidgetReviewsQuery;
    export let reviewsService: ProductReviewsMiniSliderWidgetReviewsService;
    export let reviewsStorefrontValuesService: ReviewsStorefrontValuesService;
    export let productIdManager: ProductIdManagerInterface;
    export let lowestRating: number;
    export let onlyPinnedReviews: boolean;
    export let reviewsGalleryManager: ReviewsGalleryManager;
    export let afterWidgetInject: () => void;

    const reviewsSettings$ =
        reviewsStorefrontValuesService.selectReviewsSettings();
    const reviewsBranding$ =
        reviewsStorefrontValuesService.selectReviewsBrandingOptions();

    const reviews$ = reviewsQuery.all$;
    const reviewsStatus$ = reviewsQuery.status$;

    const handleOpenReview = (event: CustomEvent) => {
        const reviewId = event.detail;
        reviewsGalleryManager.openReviewModal({
            reviews$,
            activeReviewId: reviewId,
            widgetName: REVIEWS_WIDGET_NAMES.PRODUCT_REVIEWS_MINI_SLIDER_WIDGET,
        });
    };

    onMount(() => {
        const productIdSubscription = productIdManager.productId$
            .pipe(
                filter((productId): productId is number => productId !== null),
                tap((productId) => {
                    lastValueFrom(
                        reviewsService.getReviews({
                            productId,
                            onlyProductReviews: true,
                            sortingOptions: [
                                "withPhotos",
                                "mostHelpful",
                                "mostRecent",
                            ].join(","),
                            lowestRating: lowestRating,
                            onlyPinnedReviews: onlyPinnedReviews,
                        })
                    );
                })
            )
            .subscribe();

        afterWidgetInject();

        return () => {
            productIdSubscription.unsubscribe();
        };
    });
</script>

{#if $reviewsBranding$}
    <ReviewsTheme branding={$reviewsBranding$}>
        {#if $reviewsSettings$}
            <ProductReviewsMiniSlider
                reviews={$reviews$}
                reviewsStatus={$reviewsStatus$}
                on:openReview={handleOpenReview}
            />
        {/if}
    </ReviewsTheme>
{/if}

<style lang="postcss" global>
    @import "../../../../themes/default/default.css";
    @import "../../../../themes/globals.css";
</style>
